import { createContext, useContext } from 'react';
import { AcquireNewCustomerType } from 'apps/acp/packages/acquire-new-customer';

export const AcquireNewCustomerContext = createContext<AcquireNewCustomerType>(
  null as any
);

export const useAcquireNewCustomer = () =>
  useContext(AcquireNewCustomerContext);
